import React from 'react'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import About from '../components/About'
import Services from '../components/Services'
import Contact from '../components/Contact'
import Footer from '../components/Footer'
import WhyChooseUs from '../components/WhyChooseUs'
import FloatingButtons from '../components/FloatingButtons'

const Home = () => {
  return (
    <div>
      <Navbar/>
      <Hero/>
      <About/>
      <Services/>
      <WhyChooseUs/>
      <Contact/>
      <Footer/>
      
    </div>
  )
}

export default Home
